import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Nenhuma oferta ainda',
  hint: 'Crie a primeira oferta com imagem, texto e uma ação. A equipe Bodyprint revisa e decide para quem ela aparece no app.',
  filteredTitle: 'Nenhuma oferta neste status',
  filteredHint: 'Escolha outra aba para ver as demais ofertas.',
  create: 'Nova oferta',
} satisfies TranslationTree;
